import { render, staticRenderFns } from "./SettingsOverall.vue?vue&type=template&id=03c10c8a&scoped=true&"
import script from "./SettingsOverall.vue?vue&type=script&lang=js&"
export * from "./SettingsOverall.vue?vue&type=script&lang=js&"
import style0 from "./SettingsOverall.vue?vue&type=style&index=0&id=03c10c8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c10c8a",
  null
  
)

export default component.exports